<template>
  <div class="w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-4">
    <vs-card
      id="discrepancy-donut-by-supplier-loading"
      class="vs-con-loading__container px-2 widget-card"
      style="position: relative"
    >
      <card-header :title="$t('widget_discrepancies_by_supplier')">
        <feather-icon
          icon="FilterIcon"
          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
          @click="getDiscrepanciesByVendor"
        />

        <feather-icon
          icon="RefreshCwIcon"
          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
          @click="resetDates"
        />
      </card-header>
      <vs-row>
        <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="pr-1 mt-4">
          <datepicker
            placeholder="Start Date"
            :format="format"
            v-model="startDate"
          ></datepicker>
        </vs-col>
        <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="pl-1 mt-4">
          <datepicker
            placeholder="End Date"
            :format="format"
            v-model="endDate"
          ></datepicker>
        </vs-col>
      </vs-row>

      <!-- Chart -->
      <div class="body-card-widget">
        <donut-chart
          :chartId="'donutChart'"
          height="275"
          :series="donutChart.series"
        />
      </div>
    </vs-card>
  </div>
</template>

<script>
import DonutChart from '@/views/apps/accounting/components/DonutChart.vue'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import discrepancy from '@/http/requests/discrepancy'
import loading from '@/mixins/Loading'
import CardHeader from './CardHeader.vue'

export default {
  components: {
    DonutChart,
    Datepicker,
    CardHeader,
  },
  mixins: [loading],
  computed: {
    isLoading() {
      return this.loading.chart
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('discrepancy-donut-by-supplier-loading')
      } else {
        this.closeLoading('discrepancy-donut-by-supplier-loading')
      }
    },
  },
  data() {
    return {
      startDate: moment().startOf('month').format('MM-DD-YYYY'),
      endDate: moment().format('MM-DD-YYYY'),
      format: 'MM/dd/yyyy',
      donutChart: { series: [], labels: [], colors: [] },
      params: {
        startDate: null,
        endDate: null,
      },
      loading: {
        chart: false,
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getDiscrepanciesByVendor()
    },
    getDiscrepanciesByVendor() {
      this.formatDatesToDB()
      this.loading.chart = true
      discrepancy
        .getDiscrepanciesByVendor(this.params)
        .then((res) => {
          let vendors = res.data.items
          this.donutChart.labels = vendors.map(({ VendorName }) => VendorName)

          this.vendors = vendors.map((item) => ({
            id: item.VendorId,
            name: item.VendorName,
          }))

          this.donutChart.series = vendors.map(({ total }) => parseInt(total))
          this.fillDonut()
          this.loading.chart = false
        })
        .catch((err) => {
          this.loading.chart = false
          console.log(err)
        })
    },
    fillDonut() {
      let colors = [
        '#3B93A5',
        '#F7B844',
        '#ADD8C7',
        '#EC3C65',
        '#CDD7B6',
        '#C1F666',
        '#D43F97',
        '#1E5D8C',
        '#421243',
        '#7F94B0',
        '#EF6537',
        '#C0ADDB',
      ]
      ApexCharts.exec(
        'donutChart',
        'updateOptions',
        {
          fill: {
            colors: colors,
          },
          legend: {
            markers: {
              fillColors: colors,
            },
          },
          labels: this.donutChart.labels,
          tooltip: {
            fillSeriesColor: false,
          },
        },
        false,
        true
      )
    },
    formatDatesToDB() {
      this.params.startDate = moment(this.startDate).format('YYYY-MM-DD')
      this.params.endDate = moment(this.endDate).format('YYYY-MM-DD')
    },
    resetDates() {
      this.startDate = moment().startOf('month').format('MM-DD-YYYY')
      this.endDate = moment().format('MM-DD-YYYY')
      this.getDiscrepanciesByVendor()
    },
  },
}
</script>